(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lms-social-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lms-social-videos')) {
    customElements.define('lms-social-videos', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.sv__track');
        this.videos = [...this.querySelectorAll('video')];
        this.visible = new Map();
        this.manualPause = new Set();
        this.manualPlay = new Set();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 749px)');
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => this.visible.set(entry.target, entry.intersectionRatio));
          this.sync();
        }, { threshold: [0, .5, .65, 1] });
        this.videos.forEach(video => {
          const button = video.closest('.sv__media').querySelector('.sv__play');
          button.hidden = false;
          this.observer.observe(video);
          video.addEventListener('playing', () => {
            video.dataset.ready = '';
            button.setAttribute('aria-pressed', 'true');
            button.setAttribute('aria-label', button.dataset.pause);
          }, options);
          video.addEventListener('pause', () => {
            button.setAttribute('aria-pressed', 'false');
            button.setAttribute('aria-label', button.dataset.play);
          }, options);
          video.addEventListener('ended', () => { this.manualPause.add(video); this.manualPlay.delete(video); }, options);
          video.addEventListener('error', () => { delete video.dataset.ready; this.manualPause.add(video); }, options);
          button.addEventListener('click', () => {
            if (!video.paused) {
              this.manualPause.add(video);
              this.manualPlay.delete(video);
              video.pause();
            } else {
              this.manualPause.delete(video);
              this.manualPlay.add(video);
              this.videos.filter(other => other !== video).forEach(other => { other.pause(); this.manualPlay.delete(other); });
              this.start(video);
            }
          }, options);
        });
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.motion.addEventListener('change', () => this.sync(), options);
        this.mobile.addEventListener('change', () => this.sync(), options);
        this.track.addEventListener('scroll', () => this.navigation(), { ...options, passive: true });
        this.resize = new ResizeObserver(() => this.navigation());
        this.resize.observe(this.track);
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => {
          this.track.scrollBy({ left: this.track.clientWidth * Number(button.dataset.direction), behavior: this.motion.matches ? 'instant' : 'smooth' });
        }, options));
        this.navigation();
      }
      start(video) {
        if (!video.src) {
          video.src = video.dataset.src;
          video.muted = true;
          video.loop = this.dataset.loop === 'true';
        }
        const result = video.play();
        if (result) result.catch(() => {});
      }
      sync() {
        const allowAuto = this.dataset.autoplay === 'true' && !this.motion.matches && !navigator.connection?.saveData;
        const limit = this.mobile.matches ? 1 : Number(this.dataset.limit);
        const candidates = this.videos.filter(video => !document.hidden && (this.visible.get(video) || 0) >= .65 && !this.manualPause.has(video) && (allowAuto || this.manualPlay.has(video))).sort((a, b) => Number(this.manualPlay.has(b)) - Number(this.manualPlay.has(a)) || this.visible.get(b) - this.visible.get(a)).slice(0, limit);
        this.videos.forEach(video => {
          if (candidates.includes(video)) { if (video.paused) this.start(video); }
          else video.pause();
        });
      }
      navigation() {
        const nav = this.querySelector('.sv__navigation');
        if (!nav) return;
        nav.hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
        nav.querySelector('[data-direction="-1"]').disabled = this.track.scrollLeft <= 1;
        nav.querySelector('[data-direction="1"]').disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.resize?.disconnect();
        this.videos?.forEach(video => { video.pause(); video.removeAttribute('src'); video.load(); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
